module.exports = __webpack_public_path__ + "img/SM-wholesale shoplogo.1cc0916c.svg";